module.exports = __webpack_public_path__ + "static/img/r_1.79cbcd4e.png";